import React from "react";
export default function Icon(props) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.09375 4.59375L9 8.39063L15.3281 4.59375M3.9375 13.7283C3.00552 13.7283 2.25 12.9727 2.25 12.0408V5.4375C2.25 4.50552 3.00552 3.75 3.9375 3.75H14.0625C14.9945 3.75 15.75 4.50552 15.75 5.4375V12.0408C15.75 12.9727 14.9945 13.7283 14.0625 13.7283H3.9375Z"
        stroke="#13816F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
